import {Moment} from "moment";
import {UserGroupPermissions} from "../types/userGroupPermissions";

export function setDateRangeLimit(
  startDate: Moment,
  endDate: Moment,
  advanced: boolean
) {
  let range: [moment.Moment, moment.Moment] = [startDate, endDate];
  if (advanced) return range;

  const start = startDate;
  const end = endDate;
  const rangeLimit = end.clone().subtract(1, 'years');

  range = [rangeLimit, end];
  if (rangeLimit.isBetween(start, end)) return range;

  range = [start, end];
  return range;
}

export const copyDefaultTimeRange = (originalMoment: Moment, newMoment: Moment) => {
  return originalMoment.clone().set({
    year: newMoment.year(),
    month: newMoment.month(),
    date: newMoment.date()
  })
}

export const getDateRange = (previewDatasetId: string, userGroupPermissions: UserGroupPermissions, isTnw: boolean, isDwf: boolean) => {
  const isConfidential = userGroupPermissions.confidentialDatasetIds?.includes(previewDatasetId)
  return (isConfidential || isTnw || isDwf)
    ? userGroupPermissions.dateRange
    : userGroupPermissions.analyticsDateRange
}
